import { z } from 'zod';
export const createAgencySchema = z.object({
    code: z.string().min(1).max(32),
    name: z.string().min(1).max(200),
    active: z.boolean().default(true),
    order: z.number().int().nonnegative().optional(),
    standardRate: z.number().nullable().optional(),
    overtimeRate: z.number().nullable().optional(),
    rateNotes: z.string().nullable().optional(),
});
export const updateAgencySchema = createAgencySchema.partial();
//# sourceMappingURL=agency.js.map